









































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import ProposalProgress from '@/modules/direct-sales/components/proposal-progress/proposal-progress.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { stringService, httpService, notificationService } from '@/services';
import _ from 'lodash';
import moment from 'moment';
import { httpMixin, momentMixin, numeralMixin } from '@/modules/neodash/mixins';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AxiosError, AxiosResponse } from 'axios';
import { CONFIG } from '@/config';
import { Http } from '@/decorators';
import { AUTH_GET_TOKEN, AUTH_GET_USERNAME } from '@/store/modules/authentication/types';
import { GET_LOADING } from '@/store/types';
import { Getter } from 'vuex-class';
import ProjectLoader from '@/modules/dap/components/project-loader/project-loader.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import numeral from 'numeral';

@Component({
  components: {
    ActionBar,
    PageLoader
  }
})
export default class DirectSalesHistoricClientPage extends Vue {
  @Prop({ required: true })
  consumerId: number;

  @Prop({ required: false })
  proposalId: number;

  @Prop({ required: false })
  search: string;

  public state: any = {
    consumer: {},
    historicTotal: [],
    historic: []
  };

  public numeral = numeral;

  public goBack() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE,
      params: {
        proposalId: String(this.proposalId),
        search: String(this.search)
      }
    });
  }

  public getHistoricSalesClient() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/historic/sales/vehicle/${this.consumerId}`)
      .then((res: AxiosResponse) => {
        this.state.historic = _(res.data)
          .filter((f: any) => f && !f.dateCanceled)
          .groupBy(function(f) {
            return f.color + f.idFamily + f.idModel + f.dateSales + f.color + f.typeClient + f.cpF_CNPJ;
          })
          .map((m: any) => ({
            familyName: m[0].familyName,
            idFamily: m[0].idFamily,
            model: m[0].model,
            idModel: m[0].idModel,
            color: m[0].color,
            typeClient: m[0].typeClient,
            nameConsumer: m[0].nameConsumer,
            cpfCnpj: this.formatarCampo(m[0].cpF_CNPJ),
            dateSales: m[0].dateSales ? moment(m[0].dateSales).format('DD/MM/YYYY') : '',
            dateOrder: m[0].dateSales,
            total: m.length
          }))
          .orderBy((o: any) => o.familyName)
          .orderBy((o: any) => o.dateOrder)
          .value();

        this.state.historicTotal = _(res.data)
          .groupBy(function(f) {
            return f.idFamily;
          })
          .map((m: any) => ({
            familyName: m[0].familyName,
            idFamily: m[0].idFamily,
            model: m[0].model,
            idModel: m[0].idModel,
            color: m[0].color,
            dateOrder: m[0].dateSales,
            cpfCnpj: this.formatarCampo(m[0].cpfCnpj),
            dateSales: m[0].dateSales ? moment(m[0].dateSales).format('DD/MM/YYYY') : '',
            total: m.length,
            totalcancel: _(m)
              .filter((f: any) => f && f.dateCanceled)
              .value().length,
            totalliquid:
              m.length -
              _(m)
                .filter((f: any) => f && f.dateCanceled)
                .value().length,
            media:
              _(m)
                .filter((f: any) => f && f.dateCanceled)
                .value().length > 0 && m.length > 0
                ? (_(m)
                    .filter((f: any) => f && f.dateCanceled)
                    .value().length /
                    m.length) *
                  100
                : 0
          }))
          .orderBy((o: any) => o.familyName)
          .orderBy((o: any) => o.dateOrder)
          .value();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public getConsumer() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/consumer/${this.consumerId}`)
      .then((res: AxiosResponse) => {
        this.state.consumer = {
          id: res.data.id,
          name: res.data.name,
          cnpj: this.formatarCampo(res.data.cpfCnpj),
          idSalesChannel: res.data.idSalesChannel,
          uf: res.data.uf,
          city: res.data.city,
          units: res.data.qtdPurchase,
          updatedAt: res.data.lastPurchase ? moment(res.data.lastPurchase).format('DD/MM/YYYY') : '',
          descriptionSalesChannel: res.data.descriptionSalesChannel
        };
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public formatarCampo(cpf_cnpj) {
    if (cpf_cnpj) {
      cpf_cnpj = cpf_cnpj.replace(/(\.|\/|\-)/g, '');
      if (cpf_cnpj.length <= 11) {
        cpf_cnpj = this.mascaraCpf(cpf_cnpj);
      } else {
        cpf_cnpj = this.mascaraCnpj(cpf_cnpj);
      }
    }
    return cpf_cnpj;
  }

  public mascaraCpf(valor: string) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  public mascaraCnpj(valor: string) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  }

  public mounted() {
    this.getConsumer();
    this.getHistoricSalesClient();
  }
}
